import { createSlice } from "@reduxjs/toolkit";

import {
  CmsBlocksDataState,
  CmsPageItem,
} from "../../utils/interfaces/cmsBlock";

const initialState: CmsBlocksDataState = {} as CmsBlocksDataState;
const initialStatePage: CmsPageItem = {} as CmsPageItem;

export const cmsBlockSlice = createSlice({
  name: "cmsBlock",
  initialState: {
    contactUs: initialState,
    footer: initialState,
    helpusGrow: initialState,
    contactSlaes: initialState,
    termsAndConditions: initialStatePage,
  },
  reducers: {
    setFooter: (state, action) => {
      state.footer = action.payload;
    },
    setHelpUsGrow: (state, action) => {
      state.helpusGrow = action.payload;
    },
    setContactSales: (state, action) => {
      state.contactSlaes = action.payload;
    },
    setContactUs: (state, action) => {
      state.contactUs = action.payload;
    },
    setTermsAndConditions: (state, action) => {
      state.termsAndConditions = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setFooter,
  setHelpUsGrow,
  setContactSales,
  setContactUs,
  setTermsAndConditions,
} = cmsBlockSlice.actions;

export default cmsBlockSlice.reducer;
